import {
    Outlet,
    Route,
    Routes,
    useLocation,
    useNavigate,
} from 'react-router-dom';
import { StepsLayout } from './steps.layout';
import { FC, useEffect } from 'react';
import { useRegisterContext } from './register.context';
import { SplashScreenLayout } from 'components/layouts/splash-screen.layout';

const Routing: FC = () => {
    const { active_step, steps, setStep } = useRegisterContext();

    const stepsKey = Object.keys(steps);
    const navigate = useNavigate();
    const location = useLocation();
    const { pathname } = location || '/';

    const stepKey: string = extractPathSegment(pathname || '');

    const onPrev = () => {
        const stepKeys = Object.keys(steps).slice(0, 4);
        const currentIndex = stepKeys.indexOf(stepKey || '0');

        if (stepKey === 'ticket') {
            const from = (location.state as any)?.from;
            const fromPath = from?.pathname;

            if (
                typeof fromPath === 'string' &&
                fromPath.startsWith('/register/') &&
                !fromPath.startsWith('/register/ticket')
            ) {
                navigate(fromPath, { replace: true });
                return;
            }

            const fallbackKey = stepKeys[Math.max(active_step, 0)] || 'profile';
            navigate('/register/' + fallbackKey, { replace: true });
        } else if (currentIndex > 0) {
            navigate('/register/' + stepKeys[currentIndex - 1]);
        }
    };

    useEffect(() => {
        if (stepKey) setStep(stepKey);
    }, [stepKey, setStep]);

    return stepKey ? (
        <Routes>
            {stepsKey.map((step) => (
                <Route
                    key={step}
                    path={step}
                    element={
                        <StepsLayout
                            step={{ ...steps[step] }}
                            onPrev={onPrev}
                            children={steps[step].component}
                        />
                    }
                />
            ))}
            <Route path="*" element={<Outlet />} />
        </Routes>
    ) : (
        <SplashScreenLayout />
    );
};

export default Routing;

const extractPathSegment = (path: string): string => {
    const trimmedPath = path.replace(/^\/|\/$/g, '');
    const parts = trimmedPath.split('/');
    const registerIndex = parts.indexOf('register');
    if (registerIndex !== -1 && registerIndex + 1 < parts.length) {
        return parts[registerIndex + 1];
    }

    return '';
};
